<template>
    <div class="PinnaclesFlatener">
            <Title firstName="尖峰平谷" lastName="PEAK AND VALLEY" />
            <div class="echarts">
                <div class="selectMonitor" ></div>
                <div class="warp" >
                    <div id="PinnaclesFlatener" ref="echarts" style="height: 23vh; width: 100%" />
                </div>
                
                <div class="bottom"></div>
            </div>
    </div>
</template>

<script>
const Title = () => import("../../../../components/title/Title");
const SelectList = () => import('../../../../components/title/selectList')
import * as echarts from "echarts";
import { getSevenDays, getMonthTime, getMonthDays, getTodayTime  } from "../../../../utils/common/index";

import { monthDays } from "../../../../utils/common/DateUtil";

export default {
    data() {
        return {
            myChart : null,
            xmonth:[],
            seriesData:[{data:[0]},{data:[0]},{data:[0]},{data:[0]}],
            radio:"month",
            date:new Date(),
            ishow:false,
            currentName:"本月",
            selectList:[
                {
                    id:1,
                    name:'本月'
                },
                {
                    id:2,
                    name:'本年'
                }
            ],
        };
    },
    components: {
      	Title,SelectList
    },
    watch:{
        '$store.state.nav'(val){
            if(val == 'energy'){
                this.myChart = null;
                this.initCharts()
            }
        }
    },
    mounted() {
		window.addEventListener('resize',this.chartResize)
		window.addEventListener('beforeunload', this.clearChart);
        this.getChartData()
        
    },
    methods: {
    	clearChart(){
            // 手动触发 destroy 相关的生命周期
            this.$destroy();
        },
        chartResize(){
            //防抖
            if(this.timer)
                clearTimeout(this.timer)
            this.timer = setTimeout(()=>{
                this.myChart.resize();
            },500)
        },
    tabTitle(item){
        this.currentName = item.name
    },
    async getChartData(){
        let _this = this
        let year = new Date().getFullYear()
        let month = getMonthDays()
        let res = await this.$http.getpowerAnalysisByProjectOfOut({
            start:`${year}-${month[0]}T00:00:00Z`,
            end:`${year}-${month[month.length - 1]}T00:00:00Z`,
            projectId:_this.$store.state.projectId
        })
        // console.log(res);
        let monthData = res.data.data.result.totalResult[`year_${year}`][`month_${month[0].split('-')[0]}`]
        let data1=[],data2=[],data3=[],data4=[];
        for (let j = 1; j <= monthDays(this.date); j++) {
            let dayData = monthData['day_' + j]
            if (dayData) {
                data1.push(dayData.sum_tip?dayData.sum_tip.toFixed(2):0)  //尖
                data2.push(dayData.sum_peak?dayData.sum_peak.toFixed(2):0)  //峰
                data3.push(dayData.sum_level?dayData.sum_level.toFixed(2):0)  //平
                data4.push(dayData.sum_valley?dayData.sum_valley.toFixed(2):0)  //谷
            }else{
                data1.push("")
                data2.push("")
                data3.push("")
                data4.push("")
            }
        }
        this.seriesData = [{data:data1},{data:data2},{data:data3},{data:data4}]
        this.initCharts();
    },
    initCharts() {

		this.myChart = echarts.getInstanceByDom(document.getElementById("PinnaclesFlatener"));
		if(this.myChart == null){
			this.myChart = echarts.init(document.getElementById("PinnaclesFlatener"));
		}

      var option;
      this.xmonth = []
        for(let i = 0; i <= 30; i++){
            this.xmonth.push(i+1+'日')
        }
      option = {
        color: ["#5B8FF9", "#5AD8A6", "#5D7092", "#F6BD16","E8684A","6DC8EC","9270CA","FF9D4D","269A99","FF99C3"],
        tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(0, 10, 26, 0.8)',
            borderRadius: 8,  
            borderWidth: 0,
            shadowColor:'rgba(13, 148, 255, 0.8)',
            axisPointer: {// 坐标轴指示器，坐标轴触发有效
              type: 'line', // 默认为直线，可选为：'line' | 'shadow'
            },
            textStyle: {
                color: '#fff'
            },
        },
        title: {
            text: 'kWh',
            x: '5%',
            y: '8%',
            textStyle:{                  //标题样式
                fontSize: '12',
                fontFamily:'Source Han Sans CN',
                color:'rgba(230,243,253, 0.7)',
            }
        },
        legend: {
            icon: "roundRect",
            itemWidth: 10,
            itemHeight: 10,
            textStyle: {
                fontSize: 14,
                color:"#f0f0f0"
            },
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
       xAxis: {
            type: 'category',
            data: this.xmonth,
            axisLabel: {
                textStyle: {
                    color: "#f0f0f0",
                },
            },
        },
        yAxis: {
            type: 'value',
            // name:'kWh',
            axisLabel: {
                textStyle: {
                    color: "#fff",
                },
            },
            splitLine:{
                show:false
            }
        },
        series:  [
        
            {
                name: '尖',
                type: 'bar',
                stack: '1',
                // barWidth : 15,
                data: this.seriesData[0].data
            },
            {
                name: '峰',
                type: 'bar',
                stack: '1',
                // barWidth : 15,
                data: this.seriesData[1].data
            },
            {
                name: '平',
                type: 'bar',
                stack: '1',
                // barWidth : 15,
                data: this.seriesData[2].data
            },
            {
                name: '谷',
                type: 'bar',
                stack: '1',
                // barWidth : 15,
                data: this.seriesData[3].data
            },
        ]
            
    };

      option && this.myChart.setOption(option);
    },
  },
	beforeDestroy(){
        window.removeEventListener('resize', this.chartResize);
        window.removeEventListener('beforeunload', this.clearChart);
        if(!this.myChart) return 
        this.myChart.clear()
        this.myChart = null;
    }
};
</script>

<style lang="less" scoped>
.PinnaclesFlatener {
  // height: 33.3vh;
  width: 20vw;
  position: fixed;
  top: 39vh;
  left: 2vw;
  z-index: 1;

  .echarts {
    position: relative;
    height:  25vh;;
    padding-bottom: 1vh;
    background: linear-gradient(
      0deg,
      rgba(0, 33, 59, 0.6) 0%,
      rgba(3, 13, 24, 0.7) 100%
    );
    .list{
        height: 10.5vh;
        width: 100%;
        position: absolute;
        left: 0;
        top: 100%;
        z-index: 11;
        text-align: left;
    }
    .selectMonitor{
        height: 1vh;
        line-height: 1vh;
        text-align: right;
        padding-right: 0.5vw;
        color: #E6F3FD ;
        cursor: pointer;
        // visibility: hidden;
        position: relative;
    }
    .bottom {
      width: 20vw;
      height: 1vh;
      background: url(../../../../assets/img/板块装饰线.png) no-repeat;
      block-size: 100% 100%;
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }
}
.power1 {
  top: 30.3vh;
}
</style>
